import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@material-ui/core";
import {
  IconCheckbox,
  IconEraser,
  IconFileSpreadsheet,
  IconFilter,
  IconPlus,
} from "@tabler/icons-react";
import CustomTable from "../../../components/common/table/CustomTable";
import { filterDatesOptions } from "../../../helpers/constants";
import DetailBLExport from "./DetailBLExport";
import { filterOptions } from "../constants/constants";
import { getHeadersBl } from "../constants/headers";
import EditBl from "./ModalEditBl";
import DrawerHistoryBl from "./DrawerHistoryBl";
import ModalUploadDocument from "./ModalUploadDocument";
import ModalDeleteBl from "./ModalDeleteBl";
import useBlExportBlTable from "../hooks/useBlExportTable";
import ModalDisableBl from "./ModalDisableBl";
import useDownloadFiles from "../hooks/useDownloadFiles";
import { generateRowsBLExport } from "../helpers/rowsHelpers";
import ModalNewBl from "./ModalNewBl";
import ModalCloneBl from "./ModalCloneBl";
import useUploadDocument from "../hooks/useUploadDocument";
import useDialogEnableAPI from "../hooks/useDialogEnableAPI";
import ModalEnableAPI from "./ModalEnableAPI";

interface props {
  hideFilters?: boolean;
  hideFooter?: boolean;
  isHome?: boolean;
}

const BLExportTable = ({ hideFilters, hideFooter, isHome }: props) => {
  const {
    userInfo,
    createdTimeFilter,
    setCreatedTimeFilter,
    creadoApi,
    setCreadoApi,
    showModalNewBL,
    openModalNewBL,
    closeModalNewBL,
    blToClone,
    openModalCloneBl,
    closeModalCloneBl,
    blToEdit,
    openModalEditBl,
    closeModalEditBl,
    idBlHistory,
    openModalBlHistory,
    closeModalBllHistory,
    iDToDisable,
    openDisableModal,
    closeDisbaleModal,
    iDToDelete,
    openDeleteModal,
    closeDeleteModal,
    fetchBls,
    values, // fromik values
    errors, // formik errors
    touched, // fromik touched inputs
    getFieldProps, // formik handler
    handleSubmit, // fromik handler
    handleClearFilters, // formik hanlder
    page, // table data
    size, // table data
    handleChangePage, // table function
    handleChangeRowsPerPage, // table function
    data, // table data
    isLoading, // table data
    isFetching, // table data
    isError, // table data
  } = useBlExportBlTable({ isHome: isHome });

  const {
    isDownloadingXlsx,
    downloadFileOriginalOrCopy,
    handleDownloadXlxs,
    handleDownloadCarta,
  } = useDownloadFiles();

  const {
    idBlUploadDocument,
    handleOpenModalUpladDocument,
    handleCloseModalUpladDocument,
  } = useUploadDocument();

  const {
    isOpen: isOpenEnable,
    openDialogEnable,
    closeDialogEnable,
  } = useDialogEnableAPI();

  const isAdminUser = userInfo?.perfil === "1" ? true : false;
  const tableOffset = page * size;

  const headers = getHeadersBl(isAdminUser);

  const rows = generateRowsBLExport(
    isAdminUser,
    tableOffset,
    fetchBls,
    downloadFileOriginalOrCopy,
    handleDownloadCarta,
    openModalCloneBl,
    openDisableModal,
    openModalEditBl,
    openModalBlHistory,
    openDeleteModal,
    handleOpenModalUpladDocument,
    data
  );

  const downloadXlsx = () =>
    handleDownloadXlxs(
      userInfo!,
      isHome,
      page,
      size,
      values,
      creadoApi,
      fetchBls
    );

  return (
    <Grid item container spacing={2}>
      <>
        {!hideFilters && (
          <Grid item xs={12} md={4}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="filtro-label">Creación BLs</InputLabel>
              <Select
                labelId="filtro-label"
                label="Creación BLs"
                value={createdTimeFilter ?? ""}
                onChange={(e) => setCreatedTimeFilter(Number(e.target.value))}
              >
                {filterDatesOptions.map((opt, index) => (
                  <MenuItem key={index} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} md={4}>
          <FormControl
            fullWidth
            variant="outlined"
            error={Boolean(errors.type && touched.type)}
          >
            <InputLabel id="filtro-label">Tipo Filtro</InputLabel>
            <Select
              labelId="filtro-label"
              label="Tipo Filtro"
              {...getFieldProps("type")}
              error={Boolean(errors.type && touched.type)}
            >
              {filterOptions.map((opt, index) => (
                <MenuItem key={index} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
            {Boolean(errors.type && touched.type) && (
              <FormHelperText>{errors.type}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          {values.type === "estado_procesamiento" ? (
            <FormControl
              fullWidth
              variant="outlined"
              error={Boolean(errors.value && touched.value)}
            >
              <InputLabel id="estado-label">Estado</InputLabel>
              <Select
                labelId="estado-label"
                label="Estado"
                {...getFieldProps("value")}
                error={Boolean(errors.value && touched.value)}
              >
                <MenuItem value="L">Procesados</MenuItem>
                <MenuItem value="P">No Procesados</MenuItem>
              </Select>
              {Boolean(errors.value && touched.value) && (
                <FormHelperText>{errors.value}</FormHelperText>
              )}
            </FormControl>
          ) : (
            <TextField
              fullWidth
              variant="outlined"
              label="Valor"
              {...getFieldProps("value")}
              error={Boolean(errors.value && touched.value)}
              helperText={
                Boolean(errors.value && touched.value) && errors.value
              }
            />
          )}
        </Grid>
        {userInfo?.perfil === "1" && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={creadoApi}
                  onChange={(_, val) => setCreadoApi(val)}
                  name="checkedA"
                />
              }
              label="Creados API"
            />
          </Grid>
        )}
        <Grid item container justifyContent="flex-end" spacing={1} xs={12}>
          <Grid item>
            <Button
              onClick={() => handleSubmit()}
              variant="contained"
              color="primary"
              startIcon={<IconFilter />}
            >
              Filtrar
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={handleClearFilters}
              variant="contained"
              color="secondary"
              startIcon={<IconEraser />}
            >
              Limpiar Filtros
            </Button>
          </Grid>
          {userInfo?.perfil === "1" && (
            <Grid item>
              <Button
                onClick={downloadXlsx}
                variant="outlined"
                startIcon={<IconFileSpreadsheet />}
                style={{ color: "green", borderColor: "green" }}
                disabled={isDownloadingXlsx}
                endIcon={isDownloadingXlsx && <CircularProgress size={20} />}
              >
                Exportar Excel
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end" spacing={1}>
          <Grid item>
            {isAdminUser === true ? (
              <Button
                startIcon={<IconCheckbox />}
                color="primary"
                variant="outlined"
                onClick={openDialogEnable}
              >
                Habilitar API
              </Button>
            ) : null}
          </Grid>
          <Grid item>
            <Button
              onClick={openModalNewBL}
              variant="contained"
              color="primary"
              startIcon={<IconPlus />}
            >
              Crear BL
            </Button>
          </Grid>
        </Grid>
      </>
      <Grid item xs={12} md={12} lg={12}>
        <CustomTable
          dense={true}
          isCollapsible
          isLoading={isLoading || isFetching}
          isError={isError}
          rows={rows}
          headers={headers}
          totalRecords={Number(data?.cantidadBls)}
          page={page}
          rowsPerPage={size}
          onChangePage={(page) => handleChangePage(page)}
          onChangeRowsPerPage={(rowsPerPage) =>
            handleChangeRowsPerPage(rowsPerPage)
          }
          CollapseContent={rows.map((row) => (
            <DetailBLExport idBl={Number(row.id)} />
          ))}
          hideFooter={hideFooter}
        />
      </Grid>
      <ModalNewBl
        isOpen={showModalNewBL}
        onClose={closeModalNewBL}
        callback={fetchBls}
      />
      <ModalCloneBl
        isOpen={Boolean(blToClone)}
        blToClone={blToClone}
        onClose={closeModalCloneBl}
        callback={fetchBls}
      />
      <ModalDisableBl
        idBl={Number(iDToDisable)}
        isOpen={Boolean(iDToDisable)}
        onClose={closeDisbaleModal}
        callback={fetchBls}
      />
      <ModalDeleteBl
        idBl={Number(iDToDelete)}
        isOpen={Boolean(iDToDelete)}
        onClose={closeDeleteModal}
        callback={fetchBls}
      />
      <EditBl
        BlToEdit={blToEdit}
        handleClose={closeModalEditBl}
        refetch={fetchBls}
      />
      <ModalUploadDocument
        id_bl={idBlUploadDocument}
        onClose={handleCloseModalUpladDocument}
        callback={fetchBls}
      />
      {idBlHistory !== undefined ? (
        <DrawerHistoryBl idBl={idBlHistory} onClose={closeModalBllHistory} />
      ) : null}

      <ModalEnableAPI isOpen={isOpenEnable} onClose={closeDialogEnable} />
    </Grid>
  );
};

export default BLExportTable;
